<template>
	<div class="pl10 mt20">
		<div class="mt20 mb20">
			<el-row>
			  <el-col :span="2">
			  	<div class="grid-content">入驻进展：</div>
			  </el-col>
			  <el-col :span="22"><div class="grid-content"><span class="main_word">{{ scheduleObj.schedule }}</span></div></el-col>
			</el-row>
			<el-row>
			  <el-col :span="22" :offset="2"><div class="grid-content" v-if="scheduleObj.content">
			  ({{scheduleObj.content}})</div></el-col>
			</el-row>
		</div>
		<span class="dib">基础信息</span><span class="line"></span>
		<div class="mb20">
			<el-form :model="basicForm" ref="basicForm" label-width="207px" class="demo-ruleForm">
				<!-- 基础信息 -->
				<!-- 公司名称 -->
			  <el-row class="mt20">
			    <el-col :span="2" :offset="2">
			    	<div class="grid-content">
			    		<!-- <span class="main_word mr4">*</span> -->
			    		<span class="form_color">公司名称：</span>
			    	</div>
			    </el-col>
			    <el-col :span="20">
			    	<div class="grid-content">
			    		{{ basicForm.supplierName }}
			    	</div>
			    </el-col>
			  </el-row>

			  <!-- 公司介绍 -->
			  <el-row class="mt20">
			    <el-col :span="2" :offset="2">
			    	<div class="grid-content">
			    		<!-- <span class="main_word mr4">*</span> -->
			    		<span class="form_color">公司介绍：</span>
			    	</div>
			    </el-col>
			    <el-col :span="20">
			    	<div class="grid-content">
			    		{{ basicForm.supplierIntro }}
			    	</div>
			    </el-col>
			  </el-row>

			  <!-- 线上店铺 -->
			  <el-row class="mt20">
			    <el-col :span="2" :offset="2">
			    	<div class="grid-content">
			    		<!-- <span class="main_word mr4">*</span> -->
			    		<span class="form_color">线上店铺：</span>
			    	</div>
			    </el-col>
			    <el-col :span="20">
			    	<div class="grid-content">
			    		{{ basicForm.otherPlatformShopUrl }}
			    	</div>
			    </el-col>
			  </el-row>

			  <!-- 办公地址 -->
			  <el-row class="mt20">
			    <el-col :span="2" :offset="2">
			    	<div class="grid-content">
			    		<!-- <span class="main_word mr4">*</span> -->
			    		<span class="form_color">办公地址：</span>
			    	</div>
			    </el-col>
			    <el-col :span="20">
			    	<div class="grid-content">
			    		<span>{{ basicForm.officeCountryName }}</span>
				      <span>{{ basicForm.officeProvinceName }}</span>
				      <span>{{ basicForm.officeCityName }}</span>
				      <span>{{ basicForm.officeDistrictName }}</span>
						<span>{{ basicForm.officeAddress }}</span>
			    	</div>
			    </el-col>
			  </el-row>
		    
		    <!-- 品类信息 -->
				<span class="dib">品类信息</span><span class="line"></span>
        <el-table :data="basicForm.supplierApplyCategories" border style="width: 80%;margin: 0 auto;margin-bottom:22px;margin-top: 22px">
          <el-table-column prop="categoryName" label="主营品类" width="180" align="center"></el-table-column>
          <el-table-column prop="categoryDeposit" label="品类保证金（元）" width="200" align="center">
          </el-table-column>
          <el-table-column label="品类经营特许资质电子版" align="center">
          	<template scope="scope">
    	        <img @click="previewPic($event)"  v-if="scope.row.franchiseQualificationFile" class="pic_min_skan" :src="scope.row.franchiseQualificationFile">
				<span  v-if="!scope.row.franchiseQualificationFile">不需要</span>
    	      </template>
          </el-table-column>
        </el-table>

          <!-- 供应商资质信息 -->
          <span class="dib">供应商资质信息</span><span class="second_line"></span>
          <!-- 出版社经营许可证电子版 -->
          <!--<span class="main_word mr4">*</span>-->
		<!-- 注册登记地址 -->
		<el-form-item v-if="basicForm.categoryIsBook !=1 "  label="公司注册地址：">
			<span>{{ basicForm.registeredCountryName }}</span>
			<span>{{ basicForm.registeredProvinceName }}</span>
			<span>{{ basicForm.registeredCityName }}</span>
			<span>{{ basicForm.registeredDistrictName }}</span>
			<span>{{ basicForm.registeredAddress }}</span>
		</el-form-item>
          <el-form-item  v-if="basicForm.categoryIsBook ==1 " label="出版社经营许可证电子版：" class="dib mt20">
          	<div>
          		<img @click="previewPic($event)" class="pic_skan" :src="basicForm.publicationBusinessLicenseFile">
          	</div>
          	

          </el-form-item>

          <!-- 注册登记名称 -->
          <el-form-item label="注册登记名称：">
          	<span>{{ basicForm.registeredName }}</span>
          </el-form-item>

          <!-- 注册登记地址 -->
      	  <el-form-item v-if="basicForm.categoryIsBook ==1 " label="注册登记地址：">
      	  	<span>{{ basicForm.registeredCountryName }}</span>
      	  	<span>{{ basicForm.registeredProvinceName }}</span>
      	  	<span>{{ basicForm.registeredCityName }}</span>
      	  	<span>{{ basicForm.registeredDistrictName }}</span>
			<span>{{ basicForm.registeredAddress }}</span>
          </el-form-item>
          
          <!-- 注册资金 -->
          <el-form-item label="注册资金：">
          	<span>{{ basicForm.registeredCapital }}（单位：万）</span>
            <span v-if="basicForm.registeredCapitalType == 1">人民币</span>
            <span v-if="basicForm.registeredCapitalType == 2">美元</span>
          </el-form-item>

          <!-- 注册登记电话： -->
          <!--<el-form-item label="注册登记电话：">-->
          	<!--<span>{{ basicForm.registeredPhone }}</span>-->
          <!--</el-form-item>-->

		<!-- 执照类型 -->
		<el-form-item label="执照类型：" v-show="basicForm.licenseType !=3 ">
			<span v-if="basicForm.licenseType == 1">普通营业执照</span>
			<span v-if="basicForm.licenseType == 2">三证合一／五证合一</span>
		</el-form-item>
          <!-- 营业执照号 -->
          <el-form-item label="营业执照号：">
          	<span>{{ basicForm.businessLicenseCode }}</span>
          </el-form-item>

          <!-- 营业执照电子版 -->
          <el-form-item label="营业执照电子版：">
          	<div>
          		<img @click="previewPic($event)" class="pic_skan" :src="basicForm.businessLicenseFile">
          	</div>
          </el-form-item>

          <!-- 执照有限期 -->
          <el-form-item v-show="basicForm.registeredCountry == 1" label="执照有效期：">
          	<span>{{ basicForm.businessLicenseStartDate | time}}</span> --
          	<span>{{ basicForm.businessLicenseEndDate | time}}</span>
          </el-form-item>

          <!-- 组织机构代码 -->
          <el-form-item v-if="basicForm.licenseType == 1" label="组织机构代码：">
          	<span>{{ basicForm.orgCode }}</span>
          </el-form-item>

          <!-- 组织结构代码电子版 -->
          <el-form-item v-if="basicForm.licenseType == 1" label="组织结构代码电子版：">
          	<div>
          		<img @click="previewPic($event)" class="pic_skan" :src="basicForm.orgCodeFile">
          	</div>
          </el-form-item>

          <!-- 税务登记证电子版 -->
          <el-form-item v-if="basicForm.licenseType == 1" label="税务登记证电子版：" >
          	<div>
          		<img @click="previewPic($event)" class="pic_skan" :src="basicForm.taxFile">
          	</div>
          </el-form-item>

          <!-- 开户许可证电子版 -->
          <el-form-item label="开户许可证电子版：">
          	<div>
          		<img @click="previewPic($event)" class="pic_skan" :src="basicForm.accountOpeningPermitFile">
          	</div>
          </el-form-item>

          <!-- 法定代表人证件类型 -->
          <el-form-item label="法定代表人证件类型：">
          	<span v-if="basicForm.personalCardType == 1">身份证</span>
          	<span v-if="basicForm.personalCardType == 2">护照</span>
          </el-form-item>

          <!-- 法定代表人身份证件电子版 -->
          <el-form-item label="法定代表人身份证件电子版：">
          	<div>
          		<img @click="previewPic($event)" class="pic_skan" :src="basicForm.personalCardFile">
          	</div>
          </el-form-item>

          <!-- 业务联系人信息 -->
          <div>
          	<span class="dib">业务联系人信息</span><span class="second_line"></span>
          </div>

          <!-- 联系人姓名 -->
          <el-form-item class="mt20" label="联系人姓名:">
          	<span>{{ basicForm.contactName }}</span>
          </el-form-item>

          <!-- 联系人手机号 -->
          <el-form-item label="联系人手机号:">
          	<span>{{ basicForm.contactMobile }}</span>
          </el-form-item>

          <!-- 联系人座机 -->
          <el-form-item label="联系人座机:" v-if="basicForm.contactLandline">
          	<span>{{ basicForm.contactLandline }}</span>
          </el-form-item>

          <!-- 联系人邮箱 -->
          <el-form-item label="联系人邮箱:">
          	<span>{{ basicForm.contactEmail }}</span>
          </el-form-item>

          <!-- 联系人QQ -->
          <el-form-item label="联系人QQ:">
          	<span>{{ basicForm.contactQQ }}</span>
          </el-form-item>

          <!-- 职务 -->
          <el-form-item label="职务:" v-if="basicForm.contactPosition">
          	<span>{{ basicForm.contactPosition }}</span>
          </el-form-item>

					<!-- 合同联系人信息 -->
          <div>
          	<span class="dib">合同联系人信息</span><span class="second_line"></span>
          </div>

          <!-- 联系人姓名 -->
          <el-form-item class="mt20" label="联系人姓名:">
          	<span>{{ basicForm.contractContactName }}</span>
          </el-form-item>

          <!-- 联系人手机号 -->
          <el-form-item label="联系人手机号:">
          	<span>{{ basicForm.contractContactMobile }}</span>
          </el-form-item>

          <!-- 联系人座机 -->
          <el-form-item label="联系人座机:" v-if="basicForm.contractContactLandline">
          	<span>{{ basicForm.contractContactLandline }}</span>
          </el-form-item>

          <!-- 联系人邮箱 -->
          <el-form-item label="联系人邮箱:">
          	<span>{{ basicForm.contractContactEmail }}</span>
          </el-form-item>

          <!-- 联系人QQ -->
          <el-form-item label="联系人QQ:">
          	<span>{{ basicForm.contractContactQQ }}</span>
          </el-form-item>

          <!-- 职务 -->
          <el-form-item label="职务:" v-if="basicForm.contractContactPosition">
          	<span>{{ basicForm.contractContactPosition }}</span>
          </el-form-item>


					<!-- 客服联系人信息 -->
          <div>
          	<span class="dib">客服系人信息</span><span class="second_line"></span>
          </div>

          <!-- 联系人姓名 -->
          <el-form-item class="mt20" label="联系人姓名:">
          	<span>{{ basicForm.customContactName }}</span>
          </el-form-item>

          <!-- 联系人手机号 -->
          <el-form-item label="联系人手机号:">
          	<span>{{ basicForm.customContactMobile }}</span>
          </el-form-item>

          <!-- 联系人座机 -->
          <el-form-item label="联系人座机:" v-if="basicForm.customContactLandline">
          	<span>{{ basicForm.customContactLandline }}</span>
          </el-form-item>

          <!-- 联系人邮箱 -->
          <el-form-item label="联系人邮箱:">
          	<span>{{ basicForm.customContactEmail }}</span>
          </el-form-item>

          <!-- 联系人QQ -->
          <el-form-item label="联系人QQ:">
          	<span>{{ basicForm.customContactQQ }}</span>
          </el-form-item>

          <!-- 职务 -->
          <el-form-item label="职务:" v-if="basicForm.customContactPosition">
          	<span>{{ basicForm.customContactPosition }}</span>
          </el-form-item>

			</el-form>

		</div>
		<el-dialog :visible.sync="dialogVisible" size="small">
			<img  width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
	export default {
		data () {
			return {
				businessLicenseStartDate: '',			// 开始时间
				businessLicenseEndDate: '',			// 结束时间
						dialogImageUrl: '',
				dialogVisible: false,
				isForeign: false,     // 办公地址是否是国外
				isRegisteredForeign: false,     // 注册 办公地址是否是国外
				isOneCertificate: true,    // 是否是三证合一/五证合一
				isBook: false,         // 品类是否是图书
				isTable: true,								// 是否显示主营品类表格
				isAdd: false,									// 是否添加合作类目
                scheduleObj:{
                    schedule:"",
                    content:""
                },//审核进度
				// 提交数据
				basicForm: {}
				}
		},
		methods: {
		    initBasicInfo(supplierApplyId){
		        var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findSupplierApply',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.basicForm=result.data;
                        }  else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
			},
            initProgress(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/audit/schedule',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (result && !result.code) {
                            that.scheduleObj=result.data;
                        }  else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
			// 预览图片
			previewPic (e) {
				console.log(e)
				this.dialogVisible = true;
				// 获取当前图片地址
				this.dialogImageUrl = e.currentTarget.src;
			}
		},
    
		mounted () {
			this.$nextTick(function(){
				$('.sign .el-form-item__content').css({"marginLeft":"0px"});
				//$('table tr:eq(1) .cell').css({"color":"#ff3d70","font-size":"12px"});
				$('.sign_ml .el-form-item__content').css('margin-left','0');
			});
            var supplierApplyId=this.$route.query.supplierApplyId;
            this.initBasicInfo(supplierApplyId);
            this.initProgress(supplierApplyId);
		},
		computed: {
			amount: function () {
				return 200 - this.basicForm.supplierIntro.length;
			}
		}
	}
</script>

<style type="text/css" lang="less" scoped>
	.line {
		margin-left: 3%;
		display: inline-block;
		width: 91%;
		height: 1px;
		border-bottom: 1px dashed #999;
		vertical-align: middle;
	}
	.second_line {
		margin-left: 3%;
		display: inline-block;
		width: 87%;
		height: 1px;
		border-bottom: 1px dashed #666;
		vertical-align: middle;
	}
	.word_num {
	  display: inline-block;
	  vertical-align: bottom;
	  margin-bottom: 22px;
	  margin-left: 5px;
	  color: #666;
	}
	.pic_tip {
		font-size: 12px;
		color: #ff4949;
		line-height: 1px;
		padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
	}
	.pic_skan {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
	}
	.pic_min_skan {
		width: 60px;
		height: 60px;
		margin-top: 5px;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.form_color {
		color: rgb(106, 72, 77);
	}
	.el-form-item {
		margin-bottom: 0;
	}
</style>


// WEBPACK FOOTER //
// basicInfo.vue?1814fa6d